import { render, staticRenderFns } from "./Page-1.vue?vue&type=template&id=e9949c28&scoped=true&"
var script = {}
import style0 from "./Page-1.vue?vue&type=style&index=0&id=e9949c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9949c28",
  null
  
)

export default component.exports